<template>
  <v-snackbar
    class="text-body-1"
    transition="scroll-y-transition"
    v-model="isToasterOpen"
    :color="toasterStatus"
    :multi-line="true"
    :timeout="-1"
    right
    top
  >
    <div v-html='toasterMessage'></div>
    <template v-slot:action="{ attrs }">
      <v-btn icon text v-bind="attrs" @click="closeToaster">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Toaster',

  computed: {
    ...mapGetters(['isToasterOpen', 'toasterMessage', 'toasterStatus']),
  },

  methods: {
    ...mapMutations(['setIsToasterOpen', 'setToasterMessage']),

    closeToaster() {
      this.setToasterMessage('')
      this.setIsToasterOpen(false)
    },
  },
}
</script>
